import React from "react";
import { InputNumber, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { getAdvancedFieldsForScenario } from "../../config";
import Fold from "./fold";

const formatAmount = (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const parseAmount = (value) => value.replace(/\$\s?|(,*)/g, "");

// Advanced & fee overrides: the same fold as every other on the form (audit
// form item 3), with its fields at the column's full width (item 7).
export default function AdvancedLoanFields({
  lienPosition,
  open,
  onToggle,
  appraisedValue,
  totalLoanAmount,
  secondaryLoanAmount,
  cltv,
  hcltv,
  onAppraisedValueChange,
  onTotalLoanAmountChange,
  onSecondaryLoanAmountChange,
  onCltvChange,
  onHcltvChange,
}) {
  const availableFields = getAdvancedFieldsForScenario({
    lienPosition,
    advancedOpen: true,
  });
  const visibleFields = getAdvancedFieldsForScenario({
    lienPosition,
    advancedOpen: open,
  });
  if (availableFields.length === 0) return null;

  const label = (id, text, help) => (
    <div className="ppe-label-row">
      <label htmlFor={id} className="search-fields-content-item-content-item-title">{text}</label>
      {help && (
        <Tooltip title={help}>
          <span className="ppe-tip" tabIndex={0} role="img" aria-label={`About ${text.toLowerCase()}`}>
            <QuestionCircleOutlined />
          </span>
        </Tooltip>
      )}
    </div>
  );
  const amountField = (field, text, value, onChange, help) => (
    visibleFields.includes(field) && (
      <div className="search-fields-content-item-content-item ppe-field" data-advanced-field={field}>
        {label(`ppe-advanced-${field}`, text, help)}
        <InputNumber
          id={`ppe-advanced-${field}`}
          className="ppe-input"
          prefix="$"
          value={value}
          onChange={onChange}
          formatter={formatAmount}
          parser={parseAmount}
        />
      </div>
    )
  );
  const ratioField = (field, text, value, onChange) => (
    visibleFields.includes(field) && (
      <div className="search-fields-content-item-content-item ppe-field" data-advanced-field={field}>
        {label(`ppe-advanced-${field}`, text)}
        <InputNumber id={`ppe-advanced-${field}`} className="ppe-input" suffix="%" value={value} onChange={onChange} />
      </div>
    )
  );

  return (
    <Fold id="advanced" title="Advanced & fee overrides" open={open} onToggle={onToggle} testId="ppe-advanced-toggle">
      {amountField("appraisedValue", "Appraised value", appraisedValue, onAppraisedValueChange)}
      {amountField("totalLoanAmount", "Total loan", totalLoanAmount, onTotalLoanAmountChange)}
      {amountField(
        "secondaryLoanAmount",
        "Subordinate loan balance",
        secondaryLoanAmount,
        onSecondaryLoanAmountChange,
        "Use for a closed-end subordinate mortgage balance. For a HELOC, pick Second lien and HELOC and enter the line amount and draw.",
      )}
      {(visibleFields.includes("cltv") || visibleFields.includes("hcltv")) && (
        <div className="ppe-field-pair ppe-field-pair-even">
          {ratioField("cltv", "CLTV", cltv, onCltvChange)}
          {ratioField("hcltv", "HCLTV", hcltv, onHcltvChange)}
        </div>
      )}
    </Fold>
  );
}
